// src/api/orderApi.js

const API =
  process.env.REACT_APP_API_URL ||
  'https://apimyshop.myidealtd.co.uk/api';

// ---------------------------------------------------------
// GET ALL ORDERS - ADMIN
// ---------------------------------------------------------
export const getAllOrdersAsAdmin = async () => {
  const url = `${API}/orders/all`;

  console.log('📡 Fetching admin orders from:', url);

  try {
    const response = await fetch(url, {
      method: 'GET',

      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },

      // Send HTTP-only authentication cookie
      credentials: 'include',
    });

    console.log('📡 Orders response status:', response.status);
    console.log(
      '📡 Orders response content-type:',
      response.headers.get('content-type')
    );

    // -----------------------------------------------------
    // Read response safely
    // -----------------------------------------------------
    const contentType = response.headers.get('content-type') || '';

    if (!response.ok) {
      const errorText = await response.text();

      console.error('❌ Backend response:', errorText);

      throw new Error(
        `Failed to fetch orders. HTTP ${response.status}`
      );
    }

    // -----------------------------------------------------
    // Ensure backend returned JSON
    // -----------------------------------------------------
    if (!contentType.includes('application/json')) {
      const text = await response.text();

      console.error(
        '❌ Expected JSON but backend returned:',
        text.substring(0, 500)
      );

      throw new Error(
        'Orders API returned HTML instead of JSON. Check the API URL and backend route.'
      );
    }

    const data = await response.json();

    console.log('✅ Admin orders received:', data);

    return data;
  } catch (error) {
    console.error('❌ getAllOrdersAsAdmin error:', error);

    throw error;
  }
};